export default __webpack_public_path__ + "static/applet-21-set-1-671c9017ae7843598c3e490c924c4d17.webp";